export const meta = {
    keyExpr: 'kod_spr_smet',
    columns: [
        {
            name: 'kod_smet',
            caption: 'Код',
            dataField: 'kod_smet',
            allowEditing: true,
            width: 250,
            index: 1,
            visible: true,
        },
        {
            name: 'kod_spr_smet',
            caption: 'kod_spr_smet',
            dataField: 'kod_spr_smet',
            allowEditing: true,
            width: 250,
            index: 2,
            visible: false,
        },
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: true,
            index: 3,
            width: 450,
            visible: true,
        },

        {
            name: 'sap',
            caption: 'Фин.сист.',
            dataField: 'sap',
            allowEditing: false,
            index: 4,
            width: 120,
            visible: true,
        },
        {
            name: 'soderg',
            caption: 'soderg',
            dataField: 'soderg',
            allowEditing: true,
            width: 250,
            index: 5,
            visible: false,
        },
        {
            name: 'dat_start_modified',
            caption: 'Дата начала действия',
            dataField: 'dat_start_modified',
            allowEditing: true,
            width: 150,
            index: 6,
            visible: false,
        },
        {
            name: 'dat_finish_modified',
            caption: 'Дата окончания действия',
            dataField: 'dat_finish_modified',
            allowEditing: true,
            width: 150,
            index: 7,
            visible: false,
        },
        {
            name: 'dpk',
            caption: 'dpk',
            dataField: 'dpk',
            allowEditing: true,
            width: 250,
            index: 8,
            visible: false,
        },
        {
            name: 'kod_parent',
            caption: 'kod_parent',
            dataField: 'kod_parent',
            allowEditing: true,
            width: 250,
            index: 9,
            visible: false,
        },
        {
            name: 'polzov',
            caption: 'polzov',
            dataField: 'polzov',
            allowEditing: true,
            width: 250,
            index: 10,
            visible: false,
        },
        {
            name: 'prizn',
            caption: 'Неосновная деятельность',
            dataField: 'prizn',
            allowEditing: true,
            width: 250,
            dataType: 'boolean',
            index: 11,
            visible: true,
        },
        {
            name: 'kod_direct',
            caption: 'kod_direct',
            dataField: 'kod_direct',
            allowEditing: true,
            width: 250,
            index: 12,
            visible: false,
        },
        {
            name: 'repl_code',
            caption: 'repl_code',
            dataField: 'repl_code',
            allowEditing: true,
            width: 250,
            index: 13,
            visible: false,
        },
        {
            name: 'pr_post',
            caption: 'pr_post',
            dataField: 'pr_post',
            allowEditing: true,
            width: 250,
            index: 14,
            visible: false,
        },
        {
            name: 'pr_cons',
            caption: 'pr_cons',
            dataField: 'pr_cons',
            allowEditing: true,
            width: 250,
            index: 15,
            visible: false,
        },
        {
            name: 'prib',
            caption: 'Прибыль',
            dataType: 'boolean',
            dataField: 'prib',
            allowEditing: true,
            width: 120,
            index: 16,
            visible: true,
        },
        {
            name: 'proch',
            caption: 'Прочие',
            dataField: 'proch',
            dataType: 'boolean',
            allowEditing: true,
            width: 120,
            index: 17,
            visible: true,
        },
        {
            name: 'dr',
            caption: 'Расход',
            dataField: 'dr',
            allowEditing: true,
            width: 120,
            dataType: 'boolean',
            index: 18,
            visible: true,
        },
        {
            name: 'included',
            caption: 'Статья включена в родительскую',
            dataField: 'included',
            allowEditing: true,
            width: 250,
            dataType: 'boolean',
            index: 19,
            visible: true,
        },
        {
            name: 'name_sap',
            caption: 'name_фин.сист.',
            dataField: 'name_sap',
            allowEditing: true,
            editor: {
                type: 'default',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 20,
            visible: false,
        },
        {
            name: 'kod_sap',
            caption: 'kod_фин.сист.',
            dataField: 'kod_sap',
            allowEditing: true,
            width: 250,
            index: 21,
            visible: false,
        },
        {
            name: 'path',
            caption: 'path',
            dataField: 'path',
            allowEditing: true,
            width: 250,
            index: 22,
            visible: false,
        },
    ],
    api: {
        select: 'mped./mped/issprsmet-select/get',
        save: 'mped./mped/issprsmet-save/set',
    },
    viewId: 'issprsmet-view',
    parentIdExpr: 'kod_parent',
    title: 'Справочник статей доходов и расходов',
    icon: 'child-svg',
    findTool: 'filter',
    maxWidth: 'w-auto',
};

export const gridMeta = {
    keyExpr: 'kod_spr_smet',
    scrollingMode: 'standart',
    maxWidth: 'max-w-96',
    columns: [
        {
            name: 'kod_smet',
            caption: 'Код',
            dataField: 'kod_smet',
            allowEditing: true,
            index: 1,
            visible: true,
            fixed: true,
        },
    ],
    api: {
        select: 'mped./mped/issprsmet-select/get',
        save: 'mped./mped/issprsmet-save/set',
    },
};

export const args = {
    select: 'mped./mped/issprsmet-select/get',
};
